module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var getHeight = function(attribute) {
    if (attribute.hidden) {
        return 0
    } else if (['dyn-dict-select'].indexOf(attribute.type)!=-1) {
        return 122;
    } else if (['text-area'].indexOf(attribute.type)!=-1) {
        return 180;
    } else if (['reference-select'].indexOf(attribute.type)!=-1) {
        return 197;
    } else if (['feature-multi'].indexOf(attribute.type)!=-1) {
        return 448;
    } else return 104;
} 
    ; __append("\n<div class=\"adapted-wrapper\">\n    <div class=\"adapted-section\">\n    ")
    ; 
    var halfHeight = _.reduce(attributes, function(height, attribute) {
            return height + getHeight(attribute);
        }, 0) / 2;
    
    ; __append("\n\n    ")
    ; 
    _.reduce(attributes, function(height, attribute) {
        var control = _.reduce(attribute, function(result, value, field) {
            result['data-control-' + field] = value;
            return result;
        }, {});

        if(!attribute.hidden) { 
    ; __append("\n            <div class=\"section\">\n                <div ")
    ; __append( Html.attributes(control) )
    ; __append(">\n                    ")
    ; __append( attribute['html-value'] )
    ; __append("\n                </div>\n            </div>\n        ")
    ;  } else { 
    ; __append("\n            <div ")
    ; __append( control )
    ; __append("></div>\n        ")
    ;  }

        height = height + getHeight(attribute);

        if (height > halfHeight && height != -1) {
        
    ; __append("\n    </div>\n    <div class=\"adapted-section\">\n        ")
    ; 
            return -1;
        } else {
            return height;
        }
    }, 0);
    
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}